import React from 'react';

interface RocOptionsTableProps {
	children: React.ReactNode;
}

/**
 * Placeholder component to display simple listing table
 */
export default function RocOptionsTable(props: RocOptionsTableProps) {
	const { children } = props;

	return (
		<div className="roc-product-detail-table">
			<div className="roc-product-detail-table__responsive">
				<table className="roc-product-detail-table__table">{children}</table>
			</div>
		</div>
	);
}
